<template>
  <div class="JiuXiang">
    <!--春季：1-3月-->
    <div class="spring" v-if="nowMoth >= 3 && nowMoth <= 5">
      <div class="banner">
        <img width="100%" src="../../../assets/img/JiuXiang/JiuXiang_Banner_spring.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/JiuXiang/spring_lihuaPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/JiuXiang/spring_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              梨花，蔷薇科梨属，梨树的花朵。梨树，落叶乔木，叶圆如大叶杨，干有粗皮外护，枝撑如伞。春季开花，花色洁白,如同雪花，具有淡淡的香味。梨可供生食外，还可酿酒、制梨膏、梨脯,以及药用。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/JiuXiang/spring_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/spring_square.png')" color="#2E80C6"
        borderBottomColor="#2E80C6" boxBorderColor="#93BAE6" btnBJcolor="#94BCE0" hoverBJcolor="#2D7FC8">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/spring_square.png')" color="#2E80C6"
        borderBottomColor="#2E80C6"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/JiuXiang/spring_square.png')" color="#2E80C6"
        borderBottomColor="#2E80C6" boxBorderColor="#93BAE6"></ztxzList>
    </div>
    <!-- 夏季：4-6月 -->
    <div class="summer" v-else-if="nowMoth >= 6 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/JiuXiang/JiuXiang_Banner_summer.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/JiuXiang/summer_cheliziPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/JiuXiang/summer_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              枇杷是美观的果树，果味酸甜，供鲜食、蜜饯与酿酒用；树叶晒干去毛可供药用，有化痰止咳、和胃降气之效；枇杷木材红棕色，可制作木梳、手杖、农具柄等。
            </p>
            <p>
              车厘子(英文名：CHERRIES)是欧洲甜樱桃栽培品种。音译自英语单词CHERRIES(即樱桃)，特指产于美国、加拿大、智利等美洲国家的个大皮厚樱桃。车厘子是上市最早的一种乔木果实，号称“百果第一枝”。落叶灌木果树，车厘子多呈暗红色，也有红、黄色，直径较大，新鲜的车厘子较硬，果柄较长。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/JiuXiang/summer_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/summer_square.png')" color="#A50200"
        borderBottomColor="#A50200" boxBorderColor="#DD6E72" btnBJcolor="#D1827E" hoverBJcolor="#AA0C03">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/summer_square.png')" color="#A50200"
        borderBottomColor="#A50200"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/JiuXiang/summer_square.png')" color="#A50200"
        borderBottomColor="#A50200" boxBorderColor="#DD6E72"></ztxzList>
    </div>
    <!-- 秋季：7-9月 -->
    <div class="autumn" v-else-if="nowMoth >= 9 && nowMoth <= 11">
      <div class="banner">
        <img width="100%" src="../../../assets/img/JiuXiang/JiuXiang_Banner_autumn.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/JiuXiang/autumn_huajiaoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/JiuXiang/autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              汉源花椒有着悠久的栽培历史，汉源被誉为“中国花椒之乡”。汉源花椒自唐代起就被正式列为贡品，故又名“贡椒”，以色泽丹红、粒大油重、芳香浓郁、醇麻爽口蜚声中外，2005年获得地理标志保护产品。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/JiuXiang/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/autumn_square.png')" color="#1D3492"
        borderBottomColor="#1D3492" boxBorderColor="#9AA0B9" btnBJcolor="#8F9AC8" hoverBJcolor="#283D99">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/autumn_square.png')" color="#1D3492"
        borderBottomColor="#1D3492"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/JiuXiang/autumn_square.png')" color="#1D3492"
        borderBottomColor="#1D3492" boxBorderColor="#9AA0B9"></ztxzList>
    </div>
    <!-- 冬季：10-12月 -->
    <div class="winter" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/JiuXiang/JiuXiang_Banner_winter.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/JiuXiang/winter_orangePic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/JiuXiang/winter_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              黄果柑，柑橘品种，当地人俗称青果、黄金果，主要分布于大渡河流域石棉、汉源等干热河谷地带。黄果柑由橘和橙天然杂交而来，在当地有300多年种植历史。
            </p>
            <p>九襄黄牛肉因其蛋白质含量高、脂肪含量低、味道鲜美而受人喜爱，享有“肉中骄子”的美称。</p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/JiuXiang/winter_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/winter_square.png')" color="#AC0D0A"
        borderBottomColor="#AC0D0A" boxBorderColor="#D47775" btnBJcolor="#D1827E" hoverBJcolor="#AA0C03">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/JiuXiang/winter_square.png')" color="#AC0D0A"
        borderBottomColor="#AC0D0A"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/JiuXiang/winter_square.png')" color="#AC0D0A"
        borderBottomColor="#AC0D0A" boxBorderColor="#D47775"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'JiuXiang',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  // 点位ID
      matterList:[],  //事项列表
      villages: [],  //乡镇列表
      name:'九襄镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if(this.$route.params.mapId){
  //   //   sessionStorage.setItem('mapId',this.mapId)
  //   // }
  //   // if(sessionStorage.getItem('mapId')){
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }    
  //   this.getData()
  //   this.getMatterList()

  //   // this.getData(Date.now());
  //   // console.log(this.$route.params, '??')
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res, '事项列表')
  //       if(res.data.code==200){
  //         if(res.data.rows && res.data.rows.length>0){
  //           this.matterList = res.data.rows.slice(0,5);
  //         }else{this.$message.error('暂无事项！')}
  //       }else{
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   }
  // },
};
</script>
<style scoped>
.JiuXiang {
  background: url('../../../../src/assets/img/JiuXiang/bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.spring .top_title {
  color: #2E80C6;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #2E80C6;
  height: 12%;
}

.summer .top_title {
  color: #A50200;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #A50200;
  height: 12%;
}

.autumn .top_title {
  color: #38489A;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #38489A;
  height: 12%;
}

.winter .top_title {
  color: #AC0D0A;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #AC0D0A;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}
</style>